export enum SpecieEnum {
  DOG = 1,
  CAT = 2
}
